// From: https://gist.github.com/605541#file_js_web_worker_pool.js
// Web Worker Pool (robuste Pump-Variante, ES5-kompatibel)
// size = maximale Anzahl parallel laufender Worker
function WorkerPool(size) {
    var workers = 0;     // aktuell laufende Worker
    var jobs = [];       // Warteschlange: { url, msg, cb, ctx }

    // url: Worker-Skript-URL
    // msg: Initialnachricht (wird direkt nach Start gesendet)
    // cb : function onMessage(data, worker) -> true = Worker freigeben
    // ctx: this-Kontext für cb
    this.queueJob = function (url, msg, cb, ctx) {
        jobs.push({ url: url, msg: msg, cb: cb, ctx: ctx });
        pump();
    };

    // Startet so viele Jobs, wie freie Kapazität vorhanden ist
    function pump() {
        while (workers < size && jobs.length) {
            startOne(jobs.shift());
        }
    }

    function startOne(job) {
        var worker = new Worker(job.url);
        var done = false;   // gegen doppelte Freigaben
        workers++;

        function release() {
            if (done) return;
            done = true;
            try { worker.terminate(); } catch (e) {}
            worker = null;           // Referenz freigeben (strict-mode safe)
            workers--;
            pump();                  // Kapazität frei? -> nächsten Job starten
        }

        worker.addEventListener('message', function (e) {
            var dismiss = false;
            try {
                // cb darf false/undefined zurückgeben, um Worker aktiv zu lassen
                // true => Worker freigeben und nächsten Job starten
                dismiss = !!job.cb.call(job.ctx, e.data, worker);
            } catch (err) {
                // Fehler im Callback: Worker sicher freigeben
                dismiss = true;
            }
            if (dismiss) release();
        }, false);

        worker.addEventListener('error', function () {
            // Fehler im Worker -> freigeben und weiterpumpen
            release();
        }, false);

        // initiale Nachricht senden
        worker.postMessage(job.msg);
    }
}